import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface CommentNotification {
  content: string;
  reportNumber: string;
  referenceID: string;
  updatedAt: string;
}

export interface WorkflowNotification {
  id: number;
  template: number;
  name: string;
  control_id: string;
  status: number;
  priority: number;
  extra_text: string;
  report_reference_id: string;
}


export interface PiiRemovalRequestNotification {
  requestId: number;
  removeCountry: boolean;
  removeDescription: boolean;
  removeFiles: boolean;
  removeFullName: boolean;
  removeMessages: boolean;
}

import { IRFIConversation } from './rfiMessageSlice';
export interface NotificationObject {
  reportNumber?: string;
  id: number | null;
  content: string;
  datetime: string;
  meetingDate: string;
  reportType: string;
  callType: string;
  country: string;
  isRead: boolean;
  meetingId?: number;
  notificationType: string;
  comment: CommentNotification | null;
  messageContent?: string;
  reportReferenceId?: string;
  rfiConversation?: IRFIConversation;
  piiRemovalRequest?: PiiRemovalRequestNotification | null;
  workflowNotification?: WorkflowNotification | null;
}

export type NotificationsTabState = {
  notifications: NotificationObject[];
  notificationsBadgeValue: number;
  userType: string;
  userId: number | null;
};

const initialState: NotificationsTabState = {
  notifications: [],
  notificationsBadgeValue: 0,
  userType: '',
  userId: null,
};

const notificationsTabSlice = createSlice({
  name: 'notificationsTab',
  initialState,
  reducers: {
    resetNotifications: () => initialState,
    setNotifications: (state, action: PayloadAction<NotificationObject[]>) => {
      state.notifications = action.payload;
    },
    setNotificationsBadgeNumber: (state, action: PayloadAction<number>) => {
      state.notificationsBadgeValue = action.payload;
    },
    // TODO: review if this is still necessary, and possibly remove it once
    // confirmed since we can get the user type from the auth state
    setUserType: (state, action: PayloadAction<string>) => {
      state.userType = action.payload;
    },
    setUserId: (state, action: PayloadAction<number>) => {
      state.userId = action.payload;
    },
  },
});

export const {
  resetNotifications,
  setUserType,
  setNotifications,
  setNotificationsBadgeNumber,
  setUserId,
} = notificationsTabSlice.actions;

export default notificationsTabSlice.reducer;
